/* Theme cards (ADR 0030): each card is a radio with a small preview of the app. The preview
   sets data-theme and data-mode on itself, so every colour below comes from that theme's
   tokens; the card around it uses the theme on screen now. */
.group {
  display: flex;
  flex-direction: column;
  gap: var(--space-2);
}

.label {
  color: var(--ink);
  font: var(--t-body-strong);
}

.description {
  color: var(--graphite);
  font: var(--t-small);
}

.cards {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
  gap: var(--space-4);
  margin-top: var(--space-1);
}

.field {
  display: flex;
  flex-direction: column;
}

.card {
  display: flex;
  flex: 1;
  flex-direction: column;
  gap: var(--space-3);
  padding: var(--space-3);
  border: 1px solid var(--border);
  border-radius: var(--radius-card);
  background: var(--paper);
  cursor: pointer;
  transition: border-color var(--dur) var(--ease);
}

.card[data-hovered] {
  border-color: var(--border-strong);
}

/* Selected: a 2px primary edge; the padding gives up the extra pixel so nothing moves. */
.card[data-selected] {
  padding: calc(var(--space-3) - 1px);
  border-width: 2px;
  border-color: var(--brand);
}

.card[data-focus-visible] {
  outline: var(--focus-ring);
  outline-offset: var(--focus-offset);
}

.card[data-disabled] {
  cursor: not-allowed;
}

.text {
  display: flex;
  flex-direction: column;
  gap: var(--space-1);
}

.name {
  display: flex;
  align-items: center;
  gap: var(--space-2);
  color: var(--ink);
  font: var(--t-body-strong);
}

.circle {
  flex: none;
  width: 18px;
  height: 18px;
  border: 1px solid var(--border-strong);
  border-radius: 50%;
  background: var(--paper);
  transition: border-width var(--dur) var(--ease);
}

.card[data-selected] .circle {
  border-width: 5px;
  border-color: var(--brand);
}

.optionDescription {
  color: var(--graphite);
  font: var(--t-small);
}

/* The preview: a sidebar, a header and a card in the content panel. */
.preview {
  display: flex;
  height: 96px;
  overflow: hidden;
  border: 1px solid var(--border);
  border-radius: var(--radius-control);
  background: var(--canvas);
}

.previewSidebar {
  display: flex;
  flex: none;
  flex-direction: column;
  gap: 6px;
  width: 30%;
  padding: 8px 6px;
  border-right: 1px solid var(--border);
  background: var(--sidebar);
}

.previewMark {
  width: 12px;
  height: 12px;
  margin-bottom: 4px;
  border-radius: 3px;
  background: var(--brand);
}

.previewNav,
.previewNavCurrent {
  height: 8px;
  border-radius: 3px;
  background: var(--wash);
}

.previewNavCurrent {
  background: var(--brand-tint-strong);
}

.previewMain {
  display: flex;
  flex: 1;
  flex-direction: column;
  min-width: 0;
}

.previewHeader {
  flex: none;
  height: 16px;
  border-bottom: 1px solid var(--border);
  background: var(--paper);
}

.previewPanel {
  flex: 1;
  padding: 8px;
}

.previewCard {
  display: flex;
  flex-direction: column;
  gap: 6px;
  height: 100%;
  padding: 6px 8px;
  border: 1px solid var(--border);
  border-radius: 6px;
  background: var(--paper);
}

.previewLine {
  width: 60%;
  height: 6px;
  border-radius: 3px;
  background: var(--ink);
}

.previewTags {
  display: flex;
  gap: 4px;
}

/* The done tag's filled dot is too small to see at this size, so its edge stands in for it. */
.previewTagDone,
.previewTagWaiting {
  width: 26px;
  height: 9px;
  border: 1px solid var(--color-success);
  border-radius: 3px;
  background: var(--status-success-bg);
}

.previewTagWaiting {
  border-color: var(--color-warning);
  background: var(--status-warning-bg);
}

.previewButton {
  width: 40px;
  height: 12px;
  margin-top: auto;
  border-radius: 3px;
  background: var(--brand);
}
